import React from 'react';
import MediaControls from './MediaControls.jsx';
import MediaIndicator from './MediaIndicator.jsx';
import DisplayBottomBar from './DisplayBottomBar.jsx';

/**
 * Affichage vidéo.
 * 
 * Layout :
 *  1. Bouton toggle (vidéo ↔ audio+carte)
 *  2. Vidéo (canvas)
 *  3. Timeline maître (GPS) + boutons
 *  4. Indicateur média (barre + volume) — juste en dessous
 */
const VideoDisplay = ({
  refs,
  viewState,
  timelineState,
  slaveState,
  mediaHandlers,
  canGoLive,
  statusMessage,
  rotationMode = 'locked',
  toggleRotationMode,
  isDualCameraAvailable = false,
  selectedCamera = 'back',
  onSwitchCamera,
  // Relecture : seule l'image (la timeline commune est sous la vue).
  embedded = false
}) => (
  <div
    id="video-display-section"
    ref={refs.videoDisplaySection}
    className="display-mode-section"
    style={{ display: viewState?.videoSection ? 'flex' : 'none' }}
  >
    <div
      className="canvas-wrapper"
      id="canvas-wrapper"
      ref={refs.canvasWrapper}
    >
      <div
        ref={refs.statusMessage}
        className="status-message-overlay"
        style={{ display: statusMessage ? 'flex' : 'none' }}
      >
        {statusMessage}
      </div>
      <canvas id="canvas" ref={refs.canvas} width="640" height="640"></canvas>
    </div>

    {!embedded && <>
    {/* Maître : timeline GPS universelle */}
    <MediaControls
      timelineState={timelineState}
      onPlay={mediaHandlers?.onPlay}
      onPause={mediaHandlers?.onPause}
      onStart={mediaHandlers?.onStart}
      onGoLive={mediaHandlers?.onGoLive}
      canGoLive={canGoLive}
      onTimelineInput={mediaHandlers?.onTimelineInput}
      onTimelineChange={mediaHandlers?.onTimelineChange}
      idPrefix="video-"
    />

    {/* Indicateur média + volume — juste sous la timeline */}
    <MediaIndicator
      timelineState={timelineState}
      slaveState={slaveState}
      onVolumeChange={mediaHandlers?.onVolumeChange}
      mediaType="video"
    />

    <DisplayBottomBar
      currentView="video"
      canSwitchView={viewState?.toggleVideoVisible}
      onSwitchView={() => refs.toggleViewButton.current?.click()}
      rotationMode={rotationMode}
      onToggleRotation={toggleRotationMode}
      isDualCameraAvailable={isDualCameraAvailable}
      selectedCamera={selectedCamera}
      onSwitchCamera={onSwitchCamera}
    />
    </>}

    <video
      id="video"
      ref={refs.video}
      crossOrigin="anonymous"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '1px',
        height: '1px',
        opacity: 0.001,
        pointerEvents: 'none',
        zIndex: -10
      }}
      playsInline
      webkit-playsinline="true"
      muted
      autoPlay
    ></video>
  </div>
);

export default VideoDisplay;
